module.exports = __webpack_public_path__ + "static/media/hsy-logo.c271cdaf.svg";